import { useParams } from "react-router-dom";
import ActivityItemNav from "../components/ActivityItemNav";
import ListItems from "../components/ListItems";
import itemService from "../services/ItemService";
import { createContext, useEffect, useState } from "react";
import LoadSpiner from "../components/LoadSpiner";
import { ToastContainer, toast } from "react-toastify";
import icon_info from "../assets/icons/modal-information-icon.svg";
import "react-toastify/dist/ReactToastify.css";
import icon_sort_lates from "../assets/icons/sort_latest.svg";
import icon_sort_old from "../assets/icons/sort_old.svg";
import icon_sort_az from "../assets/icons/sort_az.svg";
import icon_sort_za from "../assets/icons/sort_za.svg";
import icon_sort_cant from "../assets/icons/sort_cant.svg";
export const TodosContext = createContext();
const ItemDetail = () => {
  const priorities = [
    { value: "very-high", label: "Very High", color: "#ED4C5C" },
    { value: "high", label: "High", color: "#F8A541" },
    { value: "low", label: "Low", color: "#428BC1" },
    { value: "very-low", label: "Very Low", color: "#8942C1" },
    { value: "normal", label: "Medium", color: "#00A790" },
  ];
  const filters = [
    {
      icon: icon_sort_lates,
      value: 1,
      label: "Terbaru",
      data: "sort-selection",
    },
    { icon: icon_sort_old, value: 2, label: "Terlama", data: "sort-selection" },
    { icon: icon_sort_az, value: 3, label: "A-Z", data: "sort-selection" },
    { icon: icon_sort_za, value: 4, label: "Z-A", data: "sort-selection" },
    {
      icon: icon_sort_cant,
      value: 5,
      label: "Belum Selesai",
      data: "sort-selection",
    },
  ];
  const { id } = useParams();
  const [activityItem, setActivityItem] = useState({});
  const [todosItem, setTodosItem] = useState([]);
  const [initData, setInitData] = useState([]);
  const [isModal, setIsModal] = useState(false);
  const [isDelete, setIsDelete] = useState(false);
  const [deleteTodoItem, setDeleteTodoItem] = useState(null);
  const [updateTodoItem, setUpdateTodoItem] = useState(null);
  const [filterActive, setfilterActive] = useState(filters[0]);

  const getTodos = async () => {
    const res = await itemService.getAllTodos(id);
    const data = await res.data;
    setInitData(data);
    return data;
  };
  const getOneActivity = async () => {
    const res = await itemService.getOneActivity(id);
    setActivityItem(res);
  };
  const editTitle = (text) => {
    setActivityItem((item) => ({ ...item, title: text }));
    itemService.updateActivity(activityItem.id, {
      title: text,
    });
  };
  const sortTodo = (value) => {
    const data = [...initData];
    value === 1 && setTodosItem(data);
    value === 2 && setTodosItem(data.reverse());
    value === 3 &&
      setTodosItem(data.sort((a, b) => a.title.localeCompare(b.title)));
    value === 4 &&
      setTodosItem(data.sort((a, b) => b.title.localeCompare(a.title)));
    value === 5 &&
      setTodosItem(
        data.sort((a, b) => new Date(b.is_active) - new Date(a.is_active))
      );
  };

  const InputTodo = (data) => {
    const item = {
      id: id,
      title: data.title,
      priority: data.priority,
      create_at: new Date(Date.now()),
    };
    itemService.AddTodo(item).then((res) => {
      res.status === 201 && getTodos();
    });
  };
  const deleteTodo = () => {
    itemService.deleteTodo(deleteTodoItem.id).then((res) => {
      res.status === 200 && getTodos();
      toast.info(
        <div data-cy="modal-information" className="flex flex-row gap-2">
          <img data-cy="modal-information-icon" src={icon_info} />{" "}
          <h3 data-cy="modal-information-title">Todo Berhasil dihapus</h3>
        </div>,
        {
          icon: false,
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        }
      );
    });
    resetItemDelete();
    handleModalDeleteToggle();
  };
  const updateTodo = async (id, data) => {
    const service = await itemService.updateTodo(id, data);
    service.status === 200 && getTodos();
    return service;
  };
  const resetItemDelete = () => {
    setDeleteTodoItem(null);
  };
  const resetItemUpdate = () => {
    setUpdateTodoItem(null);
  };

  const handleModalToggle = () => {
    setIsModal(!isModal);
  };
  const handleModalDeleteToggle = () => {
    setIsDelete(!isDelete);
  };
  useEffect(() => {
    getTodos();
    getOneActivity();
  }, []);
  useEffect(() => {
    sortTodo(filterActive.value);
  }, [initData]);

  const contextValue = {
    id,
    handleModalToggle,
    InputTodo,
    isModal,
    isDelete,
    priorities,
    todosItem,
    deleteTodoItem,
    updateTodoItem,
    setUpdateTodoItem,
    filters,
    filterActive,
    setfilterActive,
    getTodos,
    handleModalDeleteToggle,
    setDeleteTodoItem,
    deleteTodo,
    resetItemDelete,
    resetItemUpdate,
    updateTodo,
    sortTodo,
  };
  return (
    <section>
      <TodosContext.Provider value={contextValue}>
        <ToastContainer />
        {Object.keys(activityItem).length === 0 ? (
          <div className="flex justify-center items-center h-[calc(100vh-200px)]">
            <LoadSpiner />
          </div>
        ) : (
          <div className="flex flex-col">
            <ActivityItemNav item={activityItem} onChange={editTitle} />
            <ListItems />
          </div>
        )}
      </TodosContext.Provider>
    </section>
  );
};

export default ItemDetail;
